import { Component } from '@angular/core'

@Component({
  selector: 'se-po-military-select-docs',
  templateUrl: './military-select-docs.component.html',
  styleUrls: ['./military-select-docs.component.scss'],
  standalone: false,
})
export class MilitarySelectDocsComponent {
}
